import React from "react";
import ReactDOM from "react-dom/client";
import "@/lib/kundenansicht";
import "@/lib/mitarbeiterModus";
import "@/lib/dropzones";
import "@/index.css";
import App from "@/App";

// Note: Domain redirects (hvkurz.de → hvkurz.de) should be handled at DNS/CDN level

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// PWA-Startbildschirm (aus index.html): bleibt sichtbar, bis Portal oder Login wirklich gerendert sind (window.__skkSplashHide),
// mindestens 900 ms, spätestens nach 8 s – so gibt es keinen weißen Zwischenbildschirm beim App-Start
const splash = document.getElementById("skk-splash");
let splashHidden = !splash;
window.__skkSplashHide = () => {
  if (splashHidden) return;
  splashHidden = true;
  const wait = Math.max(0, 900 - (Date.now() - (window.__skkSplashShownAt || 0)));
  setTimeout(() => {
    splash.classList.add("skk-splash-hide");
    setTimeout(() => { splash.remove(); document.documentElement.style.background = ""; }, 450);
  }, wait);
};
if (splash) setTimeout(window.__skkSplashHide, 8000);

// PWA: Service Worker (Installierbarkeit + Web Push, kein Caching) – auch in der Vorschau aktiv, damit Push testbar ist
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => {});
  });
}
